/**
 * The project role in Q
 */
export class ProjectRole {
  id: string
  name: string
  memberCount: number
  isDefault: boolean
  isAworkAIRole: boolean
  allowOnlyProjectMasterDataRead: boolean

  constructor(projectRole: Partial<ProjectRole>) {
    Object.assign(this, projectRole)
  }
}
